import { useQuery } from '@tanstack/react-query';
import type { GetWidgetThemeResponse } from 'server';
import { appFetch } from './appFetch';
import { widgetKeys } from './keys';

export const useGetTheme = (organizationId: string, agentId?: string) => {
  return useQuery({
    queryKey: widgetKeys.theme(organizationId, agentId),
    queryFn: async (): Promise<GetWidgetThemeResponse> => {
      const params = new URLSearchParams({ organizationId });
      if (agentId) {
        params.append('agentId', agentId);
      }
      const response = await appFetch<GetWidgetThemeResponse>(
        `/app/public/widget/theme?${params.toString()}`,
        {
          method: 'GET'
        }
      );
      return response;
    },
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000 // Cache theme for 5 minutes
  });
};
